import { render } from "./DoctorTabsHeader.vue?vue&type=template&id=33e97e0a&scoped=true"
import script from "./DoctorTabsHeader.vue?vue&type=script&lang=js"
export * from "./DoctorTabsHeader.vue?vue&type=script&lang=js"

import "./DoctorTabsHeader.vue?vue&type=style&index=0&id=33e97e0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33e97e0a"]])

export default __exports__